import { DropdownButtonType, List, ListItem, SingleSelectDropdown } from '@tableau/widgets';
import { BodyCell, DataGrid } from '@tableau/widgets-datagrid';
import React from 'react';

import { StyledCellFormatter } from '../StyledCellWrapper';

export const listCellDropdownStyle: React.CSSProperties = {
  marginTop: '6px',
  paddingLeft: '0px',
  paddingRight: '0px',
  overflowY: 'auto',
  pointerEvents: 'all',
};

const paddingOverride: React.CSSProperties = {
  padding: 0,
};

// Simplified version of the one found in DataGridCells.tsx
export function ListCell(
  getValue: (rowKey: string) => string,
  onSelectChange: (row: DataGrid.Row, value: string) => void,
  getMenuItems: (row: DataGrid.Row) => ListItem[],
  getDisplayText: (item: ListItem) => string,
  disabled?: boolean,
): React.Factory<BodyCell.Props> {
    return StyledCellFormatter(
    React.createFactory(class extends React.Component<BodyCell.Props, any> {
      displayName: 'ListCell';

      boundOnChange = this.onChange.bind(this);
      onChange(value: string) {
        onSelectChange(this.props.row, value);
      }

      render() {
        const value: string = getValue(this.props.row.key);
        const items = getMenuItems(this.props.row);
        const displayText = getDisplayText(items.find(item => item.value === value));
        const list = <List items={items}/>;
        return (
          <SingleSelectDropdown
            type={DropdownButtonType.Outline}
            list={list}
            value={value}
            testId="list-cell"
            onChange={this.boundOnChange}
            label={''}
            style={listCellDropdownStyle}
            disabled={disabled}
          >
            {displayText}
          </SingleSelectDropdown>
        );
      }
    }),
    paddingOverride
  );
}
